import React, { Component, PropTypes } from "react";
//  Moment
import moment from "moment";
moment.locale("es");
// Services
import api from "../../apiClient/v1";
import service from "../../apiClient/v2";
// Iframe
import Iframe from "react-iframe";
// Componentes
import BlackBoxIGSemanal from "./BlackBoxIGSemanal.js";
import TablaSemanal from "./TablaSemanal.jsx";
import RowInventarioSemanal from "./RowInventarioSemanal.jsx";
import SelectRange from "../../components/shared/SelectRange.jsx";
// ReactNotify
import ReactNotify from 'react-notify'
import * as ReactNotifyCSS from '../../shared/ReactNotify/ReactNotify.css'

// Modals
import {
  ModalTrigger,
  ModalCambiosNomina,
  ModalMasivoNominas,
  ModalLiderMasivo,
  ModalLiderMasivo0Nominas,
} from "./Modales.jsx";

const format = "YYYY-MM-DD";

export class ProgramacionIGSemanal extends Component {
  constructor(props) {
    super(props);
    this.blackbox = new BlackBoxIGSemanal();

    this.state = {
      idCliente: 0,
      // seleccionar el mes completo
      fechaInicialSeleccionada: moment().subtract(1, "days"),
      fechaFinalSeleccionada: moment().endOf("week"),
      // Inventarios y Filtros
      filtros: {},
      inventariosFiltrados: [],
      cantNominasSolicitud: "",
      cantCambiosNominas: "",
      cantPendientesPublicacion: "",
      opcionesLideres: props.lideres.map((usuario) => {
        return {
          valor: usuario.id,
          texto: `${usuario.nombre1} ${usuario.apellidoPaterno}`,
        };
      }),
      opcionesLideresOtros: props.lideresOtros.map((usuario) => {
        return {
          valor: usuario.id,
          texto: `${usuario.nombre1} ${usuario.apellidoPaterno}`,
        };
      }),
      opcionesSupervisores: props.supervisores.map((usuario) => {
        return {
          valor: usuario.id,
          texto: `${usuario.nombre1} ${usuario.apellidoPaterno}`,
        };
      }),
      captadoresDisponibles: props.captadores.map((usuario) => {
        return {
          valor: usuario.id,
          texto: `${usuario.nombre1} ${usuario.apellidoPaterno}`,
        };
      }),
      buttonState: { state: false, texto: "Nominas Masiva" },
      checkNominas: [],
      botonLider: { state: true },
      isLoading: false,
    };
    // referencia a todos las entradas de fecha de los inventarios
    this.rows = [];

    this.setStatusCheckBox = (idNomina, status) => {
      let lista = this.state.checkNominas.map((nominas) => {
        if (nominas.nominaDia.id == idNomina) {
          return { ...nominas, nominaDia: { id: idNomina, status: status } };
        } else if (nominas.nominaNoche.id == idNomina) {
          return { ...nominas, nominaNoche: { id: idNomina, status: status } };
        } else {
          return nominas;
        }
      });
      this.setState({ checkNominas: lista });
    };

    this.setStatusCheckBoxAll = (status) => {
      let lista = this.state.checkNominas.map(
        ({ nominaDia, nominaNoche }, index) => {
          let inventario = this.state.inventariosFiltrados[index];
          //let statusDia = inventario.ndia_calificacionNomina == 0 || inventario.ndia_calificacionNomina == null ? false : status;
          //let statusNoche = inventario.nnoche_calificacionNomina == 0 || inventario.nnoche_calificacionNomina == null ? false : status;
          //console.log(inventario)
          if (inventario.ndia_habilitada && inventario.nnoche_habilitada) {
            return {
              nominaDia: { id: nominaDia.id, status: status },
              nominaNoche: { id: nominaNoche.id, status: status },
            };
          } else if (inventario.ndia_habilitada) {
            return {
              nominaDia: { id: nominaDia.id, status: status },
              nominaNoche,
            };
          } else if (inventario.nnoche_habilitada) {
            return {
              nominaDia, //: {id: nominaDia.id, status: status} ,
              nominaNoche: { id: nominaNoche.id, status: status },
            };
          }
        }
      );
      this.setState({ checkNominas: lista });
    };

    this.fetchNominasPendientes = () => {
      api.nominas
        .getCambiosNominas(
          this.state.fechaInicialSeleccionada.format(format),
          this.state.fechaFinalSeleccionada.format(format)
        )
        .then((resp) => {
          this.setState({
            cantCambiosNominas: resp.length,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    };
    this.publicarInventarios = () => {
      let inventarios = this.state.inventariosFiltrados;
      api.inventario
        .publicarInventarios(inventarios)
        .then((resp) => {
          this.buscarInventarios();
        })
        .catch((error) => {
          console.log("error al publicar los inventarios", error);
        });
    };
    this.saveDepartureTime = (idService, departureTime) => {
      api.inventario
        .updateDepartureTime(idService, departureTime)
        .then((service) => {
          console.log("inventario actualizado correctamente");
          this.blackbox.actualizarInventario(service);
          this.setState(this.blackbox.getListaFiltrada());
        })
        .catch((error) => {
          console.log("error al actualizar", error);
        });
    };
    this.finishReviewLists = (withEmail) => {
      let initDate = this.state.fechaInicialSeleccionada.format(format);
      let finishDate = this.state.fechaFinalSeleccionada.format(format);
      service
        .lists()
        .finishReviewLists(initDate, finishDate, withEmail)
        .then(console.log("ok"))
        .catch((error) => console.log(error));
    };
  }
  componentWillMount() {
    if (this.props.idUser == 2) {
      this.state.fechaInicialSeleccionada = moment();
    }
    this.buscarInventarios(
      this.state.fechaInicialSeleccionada.format(format),
      this.state.fechaFinalSeleccionada.format(format)
    );
  }
  componentWillReceiveProps(nextProps) {
    // cuando se reciben nuevos elementos, se generand posiciones "vacias" en el arreglo de rows
    this.rows = this.rows.filter((input) => input !== null);
  }
  focusRow(index, nombreElemento) {
    let ultimoIndex = this.rows.length - 1;
    if (index < 0) {
      // al seleccionar "antes de la primera", se seleciona el ultimo
      this.rows[ultimoIndex].focusElemento(nombreElemento);
    } else if (index >= ultimoIndex) {
      // al seleccionar "despues de la ultima", se selecciona el primero
      this.rows[index % this.rows.length].focusElemento(nombreElemento);
    } else {
      // no es ni el ultimo, ni el primero
      this.rows[index].focusElemento(nombreElemento);
    }
  }
  // Metodos de los hijos
  lideresDisponibles(idNominaNoche, idNominaDia) {
    return api
      .nominaLideresDisponibles(idNominaNoche, idNominaDia)
      .lideresDisponibles();
  }

  auditoresSMUDisponibles(idNominaNoche, idNominaDia) {
    return api
      .nominaLideresDisponibles(idNominaNoche, idNominaDia)
      .auditoresSMUDisponibles();
  }
  guardarInventario(idInventario, formInventario) {
    api.inventario
      .actualizar(idInventario, formInventario)
      .then((inventarioActualizado) => {
        console.log("inventario actualizado correctamente");
        // actualizar los datos y el state de la app
        this.blackbox.actualizarInventario(inventarioActualizado);
        // actualizar los filtros, y la lista ordenada de locales
        this.setState(this.blackbox.getListaFiltrada()); // {inventariosFiltrados: ...}
      });
  }
  guardarNomina(idNomina, datos) {
    api
      .nomina(idNomina)
      .actualizar(datos)
      .then((inventarioActualizado) => {
        console.log("nomina actualizada correctamente");
        // actualizar los datos y el state de la app
        this.blackbox.actualizarInventario(inventarioActualizado);
        // actualizar los filtros, y la lista ordenada de locales
        this.setState(this.blackbox.getListaFiltrada()); // {inventariosFiltrados: ...}
      });
  }
  estadoSolicitud(idNomina, estado) {
    this.guardarNomina(idNomina, estado);
  }
  ordenarInventarios(evt) {
    evt.preventDefault();
    this.blackbox.ordenarLista();
    this.setState(this.blackbox.getListaFiltrada());
  }
  // Select de Cliente seleccionado
  onSelectClienteChanged(evt) {
    this.setState(
      {
        idCliente: evt.target.value,
      },
      () => {
        this.buscarInventarios();
      }
    );
  }
  // SELECT DE LIDER
  onSelectLiderChanged(evt) {
    this.setState({
      idLiderMasivo: evt.target.value,
    });
  }
  asignacionMasivaLider(cambiosNominas, hideModal) {
    let data = [];
    this.state.checkNominas.forEach(({ nominaDia, nominaNoche }) => {
      if (nominaDia.status && nominaNoche.status) {
        data.push(nominaDia.id);
        data.push(nominaNoche.id);
      } else if (nominaDia.status) {
        data.push(nominaDia.id);
      } else if (nominaNoche.status) {
        data.push(nominaNoche.id);
      }
    });

    if (data.length == 0) {
      console.log("No se ha seleccionado ningun inventario");
    } else {
      api.nominas
        .asignacionMasivaLider(data, cambiosNominas)
        .then((response) => {
          if (response.length > 0) {
            response.map((inventario) => {
              this.blackbox.actualizarInventario(inventario);
            });
            hideModal();
          }
          this.setState(this.blackbox.getListaFiltrada());
        })
        .catch((error) => {
          console.log("error envio", error);
        });
    }
  }
  onSelectRangoChanged(momentumFechaInicio, momentumFechaFinal) {
    this.setState(
      {
        fechaInicialSeleccionada: momentumFechaInicio,
        fechaFinalSeleccionada: momentumFechaFinal,
      },
      () => {
        let fechaInicio =
          this.state.fechaInicialSeleccionada.format("YYYY-MM-DD");
        let fechaFinal = this.state.fechaFinalSeleccionada.format("YYYY-MM-DD");
        // se llama al metodo seleccionar semana, que hace lo mismo
        this.buscarInventarios(fechaInicio, fechaFinal);
      }
    );
  }
  // Todo: recibir el idCliente desde los metodos que lo llamen
  buscarInventarios() {
    this.setState({ isLoading: true });
    this.setState({ inventariosFiltrados: [] });
    let idCliente = this.state.idCliente;
    let fechaInicio = this.state.fechaInicialSeleccionada.format(format);
    let fechaFin = this.state.fechaFinalSeleccionada.format(format);

    api.inventario
      .buscar2(fechaInicio, fechaFin, idCliente)
      .then((inventarios) => {
        this.blackbox.reset();
        let filtrados = inventarios.filter((inventario) => inventario.cliente_nombreCorto != 'SMU AI')
        filtrados.forEach((inventario) => this.blackbox.add(inventario));

        this.blackbox.ordenarLista();
        this.setState(this.blackbox.getListaFiltrada()); // {inventariosFiltrados: ...}
        let cantidadPendientes = filtrados.filter(
          (pendientes) =>
            pendientes.inv_estadoPublicacion === 1 ||
            pendientes.inv_estadoPublicacion === 3
        );
        this.setState({ cantPendientesPublicacion: cantidadPendientes.length });
        this.setState({ isLoading: false });
      });
  }
  actualizarFiltro(nombreFiltro, filtro) {
    this.blackbox.reemplazarFiltro(nombreFiltro, filtro);
    // actualizar los filtros, y la lista ordenada de locales
    this.setState(this.blackbox.getListaFiltrada());
  }
  nomina_agregarCaptador(idNomina, idCaptador) {
    api
      .nomina(idNomina)
      .agregarCaptador(idCaptador)
      .then((inventarioActualizado) => {
        this.blackbox.actualizarInventario(inventarioActualizado);
        this.setState(this.blackbox.getListaFiltrada());
      })
      .catch((error) => {
        console.log("error al agregar el captador", error);
      });
  }
  nomina_quitarCaptador(idNomina, idCaptador) {
    api
      .nomina(idNomina)
      .quitarCaptador(idCaptador)
      .then((inventarioActualizado) => {
        this.blackbox.actualizarInventario(inventarioActualizado);
        this.setState(this.blackbox.getListaFiltrada());
      })
      .catch((error) => {
        console.log("error al quitar el captador", error);
      });
  }
  nomina_cambiarAsignadosCaptador(idNomina, idCaptador, asignados) {
    api
      .nomina(idNomina)
      .cambiarAsignadosCaptador(idCaptador, { asignados })
      .then((inventarioActualizado) => {
        this.blackbox.actualizarInventario(inventarioActualizado);
        this.setState(this.blackbox.getListaFiltrada());
      })
      .catch((error) => {
        console.log("error al asignar operadores al captador", error);
      });
  }
  nomina_agregarRegionesCaptador(idNomina, idCaptador, regiones) {
    api
      .nomina(idNomina)
      .agregarRegionesCaptador(idCaptador, { regiones })
      .then((inventarioActualizado) => {
        this.blackbox.actualizarInventario(inventarioActualizado);
        this.setState(this.blackbox.getListaFiltrada());
        this.setState({ cerrarRegion: true });
      })
      .catch((error) => {
        console.log("error al agregar operadores de otras regiones", error);
      });
  }

  /*componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.initialChecked == false && prevProps == true) {
            this.data = [];
        }
    }*/

  enviarNominaMasiva(conCorreo) {
    const data = [];
    this.state.checkNominas.forEach(({ nominaDia, nominaNoche }) => {
      if (nominaDia.status && nominaNoche.status) {
        data.push(nominaDia.id);
        data.push(nominaNoche.id);
      } else if (nominaDia.status) {
        data.push(nominaDia.id);
      } else if (nominaNoche.status) {
        data.push(nominaNoche.id);
      }
    });

    if (data.length == 0) {
      this.refs.notificator.error('Inventarios', "No se ha seleccionado ningun inventario", 3000);
    } else {
      this.setState({ buttonState: { state: true, texto: "Informando..." } });
      api.nominas
        .enviarNominasMasiva(data, conCorreo)
        .then((response) => {
          if (response.length > 0) {
            response.map((inventario) => {
              this.blackbox.actualizarInventario(inventario);
            });
          }
          this.setState(this.blackbox.getListaFiltrada());
          this.setState({ buttonState: { state: false, texto: "Nominas Masiva" }, });
          this.refs.notificator.success('Inventarios', 'Nomina Informadas', 2 * 1000)
        })
        .catch((error) => {
          this.setState({ buttonState: { state: false, texto: "Nominas Masiva" }, });
          this.refs.notificator.error('Inventarios', 'Error al informar nominas', 2 * 1000)
          console.log("error envio", error);
        });
    }
  }

  aprobarNominaMasiva() {
    const data = [];
    this.state.checkNominas.forEach(({ nominaDia, nominaNoche }) => {
      if (nominaDia.status && nominaNoche.status) {
        data.push(nominaDia.id);
        data.push(nominaNoche.id);
      } else if (nominaDia.status) {
        data.push(nominaDia.id);
      } else if (nominaNoche.status) {
        data.push(nominaNoche.id);
      }
    });

    if (data.length == 0) {
      this.refs.notificator.error('Inventarios', "No se ha seleccionado ningun inventario", 3000);
    } else {
      this.setState({ buttonState: { state: true, texto: "Aprobando..." } });
      api.nominas
        .aprobarNominasMasiva(data)
        .then((response) => {
          if (response.length > 0) {
            response.map((inventario) => {
              this.blackbox.actualizarInventario(inventario);
            });
          }
          this.setState(this.blackbox.getListaFiltrada());
          this.setState({ buttonState: { state: false, texto: "Nominas Masiva" }, });
          this.refs.notificator.success('Inventarios', 'Nomina Aprobadas', 3000);
        })
        .catch((error) => {
          this.setState({ buttonState: { state: false, texto: "Nominas Masiva" }, });
          this.refs.notificator.error('Inventarios', 'Error al aprobar nominas', 3000);
          console.log("error envio", error);
        });
    }
  }

  rectificarNominaMasiva() {
    const data = [];
    this.state.checkNominas.forEach(({ nominaDia, nominaNoche }) => {
      if (nominaDia.status && nominaNoche.status) {
        data.push(nominaDia.id);
        data.push(nominaNoche.id);
      } else if (nominaDia.status) {
        data.push(nominaDia.id);
      } else if (nominaNoche.status) {
        data.push(nominaNoche.id);
      }
    });

    if (data.length == 0) {
      this.refs.notificator.error('Inventarios', "No se ha seleccionado ningun inventario", 3000);
    } else {
      this.setState({ buttonState: { state: true, texto: "Rectificando..." } });
      api.nominas
        .rectificarNominasMasiva(data)
        .then((response) => {
          if (response.length > 0) {
            response.map((inventario) => {
              this.blackbox.actualizarInventario(inventario);
            });
          }
          this.setState(this.blackbox.getListaFiltrada());
          this.setState({ buttonState: { state: false, texto: "Nominas Masiva" }, });
          this.refs.notificator.success('Inventarios', 'Nomina Rectificas.', 3000)
        })
        .catch((error) => {
          this.setState({ buttonState: { state: false, texto: "Nominas Masiva" }, });
          this.refs.notificator.error('Inventarios', 'Error al rectificar', 3000)
          console.log("error envio", error);
        });
    }
  }

  updateComentarios(idInventario, comentarios) {
    const inventario = this.state.inventariosFiltrados.filter((inventario) => {
      return inventario.inv_idInventario == idInventario;
    });
    let inv = {
      ...inventario[0],
      inv_comentarios: comentarios,
    };
    this.blackbox.actualizarInventario(inv);
    this.setState(this.blackbox.getListaFiltrada());
  }

  updateComentariosClientes(idLocal, comentarios) {
    const inventario = this.state.inventariosFiltrados.filter((inventario) => {
      return inventario.local_idLocal == idLocal;
    });
    let inv = {
      ...inventario[0],
      local_comentarios: comentarios,
    };
    this.blackbox.actualizarInventario(inv);
    this.setState(this.blackbox.getListaFiltrada());
  }

  render() {
    let fechaInicial = this.state.fechaInicialSeleccionada.format(format);
    let fechaFinal = this.state.fechaFinalSeleccionada.format(format);
    return (
      <div>
        <ReactNotify ref='notificator' className={ReactNotifyCSS} />
        <h1>Programación semanal IG</h1>
        <div>
          {/* SELECTOR DE CLIENTE */}
          <div className={"col-sm-2 form-group "}>
            <label className="control-label" htmlFor="selectCliente">
              Cliente
            </label>
            <select
              className="form-control"
              name="selectCliente"
              ref={(ref) => (this.inputIdCliente = ref)}
              value={this.state.idCliente}
              onChange={this.onSelectClienteChanged.bind(this)}
            >
              <option value="0">Todos</option>
              {this.props.clientes.map((cliente, index) => {
                return (
                  <option
                    key={index}
                    value={cliente.idCliente}
                  >{`${cliente.nombreCorto} - ${cliente.nombre}`}</option>
                );
              })}
            </select>
          </div>

          {/* SELECTOR UN RANGO DE FECHAS */}
          <div className={"col-sm-3 form-group "}>
            <label className="control-label" htmlFor="selectSemana">
              Rango de Fecha
            </label>
            <SelectRange
              startDateSelected={this.state.fechaInicialSeleccionada}
              endDateSelected={this.state.fechaFinalSeleccionada}
              onInit={() => {
                console.log("on init");
              }}
              onRangeSelected={this.onSelectRangoChanged.bind(this)}
            />
          </div>

          {/* SELECTOR LIDER MASIVO */}
          <div className={"col-sm-2 form-group "}>
            <label className="control-label" htmlFor="selectCliente">
              Asignación múltiple
            </label>
            <select
              className="form-control"
              name="selectCliente"
              value={this.state.idLiderMasivo}
              onChange={this.onSelectLiderChanged.bind(this)}
            >
              <option value="">--</option>
              {this.props.lideres.map((usuario, index) => {
                return (
                  <option
                    key={index}
                    value={usuario.id}
                  >{`${usuario.nombre1} ${usuario.apellidoPaterno}`}</option>
                );
              })}
            </select>
          </div>
          <div className={"col-sm-1 form-group "} style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            <div>
              <label className="control-label">&nbsp;</label>
              <div>
                <BotonLiderMasivo
                  inventariosFiltrados={this.state.checkNominas}
                  idLiderMasivo={this.state.idLiderMasivo}
                  liderMultiple={this.asignacionMasivaLider.bind(this)}
                  lider={this.props.lideres.find(
                    (usuario) => usuario.id === parseInt(this.state.idLiderMasivo)
                  )}
                  disabled={this.state.botonLider.state}
                />
              </div>
            </div>
            <div style={{ alignItems: 'baseline' }}>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <input
                  type="radio"
                  name='suspendidos'
                  onChange={this.actualizarFiltro.bind(this, 'filtroSuspendidos', [{valor: false, texto: false, seleccionado: true}, {valor: true, texto: true, seleccionado: true}])}
                /> Todos
              </div>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <input
                  type="radio"
                  name='suspendidos'
                  onChange={this.actualizarFiltro.bind(this, 'filtroSuspendidos', [{valor: true, texto: true, seleccionado: true}, {valor: false, texto: false, seleccionado: false}])}
                /> Suspendidos
              </div>
            </div>
          </div>
        </div>
        <div style={{ backgroundColor: 'lightblue' }}>
          <a
            className="btn btn-success btn-xs pull-right"
            href={`/inventarios/descargar-excel-por-rango?fechaInicial=${fechaInicial}&fechaFinal=${fechaFinal}&cliente=${this.state.idCliente}`}
          >
            <span className="glyphicon glyphicon-export"></span> Exportar
          </a>
          <a
            className="btn btn-success btn-xs pull-right"
            title="Pulse aquí para obtener planilla masiva de permisos covid19"
            href={`/api/covid/permission/excel-download?initDate=${fechaInicial}&endDate=${fechaFinal}&idStatePayroll=5`}
          >
            <span className="glyphicon glyphicon-export"></span> Permiso Cod19
          </a>
          <a
            className="btn btn-info btn-xs pull-right"
            target="_blank"
            href={`/inventarios/detalles?fechaInicio=${fechaInicial}&fechaFinal=${fechaFinal}`}
          >
            <span className="glyphicon glyphicon-list"></span> Detalles
          </a>
          {this.props.puedeAprobarCambiosNominas ? (
            <BotonCambioDotacion
              fechaInicial={fechaInicial}
              fechaFinal={fechaFinal}
              cantCambiosNominas={this.state.cantCambiosNominas}
              pendientes={this.fetchNominasPendientes}
            />
          ) : null}
          <BotonNominaMasiva
            informar={this.enviarNominaMasiva.bind(this)}
            aprobar={this.aprobarNominaMasiva.bind(this)}
            rectificar={this.rectificarNominaMasiva.bind(this)}
            disabled={this.state.buttonState.state}
            text={this.state.buttonState.texto}
          />
        </div>
        <TablaSemanal
          ordenarInventarios={this.ordenarInventarios.bind(this)}
          //initialChecked={false}
          handleCheckedNomina={this.setStatusCheckBoxAll.bind(this)}
          // Filtros
          filtros={this.state.filtros}
          actualizarFiltro={this.actualizarFiltro.bind(this)}
        >
          {this.state.inventariosFiltrados.length === 0 ? (
            <tr>
              <td colSpan="27" style={{ textAlign: "center" }}>
                <div
                  style={{
                    padding: "60px 0",
                    fontSize: "18px",
                    fontWeight: "bold",
                  }}
                >
                  {this.state.isLoading
                    ? "Cargando Inventarios..."
                    : "No hay inventarios para mostrar en este periodo."}
                </div>
              </td>
            </tr>
          ) : (
            this.state.inventariosFiltrados.map((inventario, index) => {
              let mostrarSeparador = false;
              let sgteInventario = this.state.inventariosFiltrados[index + 1];
              if (sgteInventario)
                mostrarSeparador =
                  inventario.inv_fechaProgramada !==
                  sgteInventario.inv_fechaProgramada;

              //nominaDia y nominaNoche
              let checkboxesNomina = this.state.checkNominas[index];
              return (
                <RowInventarioSemanal
                  // Propiedades
                  puedeModificar={this.props.puedeModificar}
                  puedeModificarCaptador={this.props.puedeModificarCaptador}
                  puedeModificarPro={this.props.puedeCambiarLiderSupervisor}
                  puedeModificarDotaciones={this.props.puedeModificarDotaciones}
                  puedeEditarStock={this.props.puedeEditarStock}
                  puedeValidarComentarios={this.props.puedeValidarComentarios}
                  key={inventario.inv_idInventario}
                  index={index}
                  ref={(ref) => (this.rows[index] = ref)}
                  inventario={inventario}
                  //estado inicial checkbox nominas
                  checkboxesNomina={checkboxesNomina}
                  setValueCheckbox={this.setStatusCheckBox.bind(this)}
                  opcionesLideres={
                    this.state.idCliente != 9
                      ? this.state.opcionesLideresOtros
                      : this.state.opcionesLideres
                  }
                  opcionesSupervisores={this.state.opcionesSupervisores}
                  captadoresDisponibles={this.state.captadoresDisponibles}
                  mostrarSeparador={mostrarSeparador}
                  // Metodos
                  lideresDisponibles={this.lideresDisponibles.bind(this)}
                  auditoresSMUDisponibles={this.auditoresSMUDisponibles.bind(
                    this
                  )}
                  guardarInventario={this.guardarInventario.bind(this)}
                  focusRow={this.focusRow.bind(this)}
                  // Metodos para modificar nomina
                  guardarNomina={this.guardarNomina.bind(this)}
                  estadoSolicitud={this.estadoSolicitud.bind(this)}
                  agregarCaptador={this.nomina_agregarCaptador.bind(this)}
                  quitarCaptador={this.nomina_quitarCaptador.bind(this)}
                  agregarRegionesCaptador={this.nomina_agregarRegionesCaptador.bind(
                    this
                  )}
                  cerrarRegion={this.state.cerrarRegion}
                  cambiarAsignados={this.nomina_cambiarAsignadosCaptador.bind(
                    this
                  )}
                  saveDepartureTime={this.saveDepartureTime}
                  //comentarios
                  updateComentarios={this.updateComentarios.bind(this)}
                  updateComentariosClientes={this.updateComentariosClientes.bind(this)}
                />
              );
            })
          )}
        </TablaSemanal>
        {this.props.idUser == 2 ? (
          <div>
            <h3>Estado auditorias FCV</h3>
            <Iframe
              url="http://sig.seiconsultores.cl/auditorias/estado-general-fcv-publico"
              width="450px"
              height="450px"
              display="initial"
              position="relative"
              allowFullScreen
            />
          </div>
        ) : null}
      </div>
    );
  }
}

ProgramacionIGSemanal.propTypes = {
  puedeModificar: PropTypes.bool.isRequired,
  puedeModificarCaptador: PropTypes.bool.isRequired,
  puedeCambiarLiderSupervisor: PropTypes.bool.isRequired,
  puedeModificarDotaciones: PropTypes.bool.isRequired,
  puedeAprobarCambiosNominas: PropTypes.bool.isRequired,
  puedeAprobarAumentoDotacion: PropTypes.bool.isRequired,
  canEditStatusService: PropTypes.bool.isRequired,
  clientes: PropTypes.array.isRequired,
  captadores: PropTypes.array.isRequired,
  supervisores: PropTypes.array.isRequired,
  lideres: PropTypes.array.isRequired,
  lideresOtros: PropTypes.array.isRequired,
  idUser: PropTypes.number,
  regiones: PropTypes.array.isRequired,
};

ProgramacionIGSemanal.defaultProps = {
  puedeModificar: false,
};

const BotonCambioDotacion = ({
  fechaInicial,
  fechaFinal,
  cantCambiosNominas,
  pendientes,
}) => {
  return (
    <ModalTrigger>
      {(isVisible, showModal, hideModal) => (
        <button className="btn btn-xs btn-info pull-right" onClick={showModal}>
          <span className={"glyphicon glyphicon-user"}></span> Cambios{" "}
          {cantCambiosNominas ? (
            <span className="badge">{cantCambiosNominas}</span>
          ) : null}
          {isVisible && (
            <ModalCambiosNomina
              fechaInicial={fechaInicial}
              fechaFinal={fechaFinal}
              pendientes={pendientes}
              hideModal={hideModal}
            />
          )}
        </button>
      )}
    </ModalTrigger>
  );
};

const BotonNominaMasiva = ({
  informar,
  aprobar,
  rectificar,
  disabled,
  text,
}) => {

  const number_day = moment().day();
  return (
    <div className="btn-group pull-right">
      <a
        className="btn btn-warning btn-xs dropdown-toggle"
        disabled={disabled}
        data-toggle="dropdown"
        href="#"
      >
        {text}
        <span className="caret"></span>
      </a>
      <ul className="dropdown-menu">
        {/*number_day == 3 && <li>
          <a onClick={() => informar(true)} href="#">
            Informar
          </a>
        </li> */}
        <li>
          <a onClick={() => informar(true)} href="#">
            Informar
          </a>
        </li>
        {/*number_day == 3 && <li>
          <a onClick={() => informar(false)} href="#">
            Informar (sin Correo)
          </a>
        </li>*/}
        <li>
          <a onClick={() => informar(false)} href="#">
            Informar (sin Correo)
          </a>
        </li>
        <li>
          <a onClick={aprobar} href="#">
            Aprobar
          </a>
        </li>
        <li>
          <a onClick={rectificar} href="#">
            Rechazar/Rectificar
          </a>
        </li>
      </ul>
    </div>
  );
};

export default ProgramacionIGSemanal;
const BotonLiderMasivo = ({
  inventariosFiltrados,
  idLiderMasivo,
  liderMultiple,
  lider,
  disabled,
}) => {
  let arr = [];
  arr.length = 0;
  inventariosFiltrados.forEach(({ nominaDia, nominaNoche }) => {
    if (nominaDia.status && nominaNoche.status) {
      arr.push(nominaDia.id);
      arr.push(nominaNoche.id);
    } else if (nominaDia.status) {
      arr.push(nominaDia.id);
    } else if (nominaNoche.status) {
      arr.push(nominaNoche.id);
    }
  });
  if (arr.length > 0) {
    return (
      <ModalTrigger>
        {(isVisible, showModal, hideModal) => (
          <button className="btn btn-md btn-success" onClick={showModal}>
            <span className={"glyphicon glyphicon-ok"}></span>
            {isVisible && (
              <ModalLiderMasivo
                hideModal={hideModal}
                totalInventarios={arr.length}
                liderMultiple={liderMultiple}
                idLiderMasivo={idLiderMasivo ? "" + idLiderMasivo : ""}
                lider={lider}
              />
            )}
          </button>
        )}
      </ModalTrigger>
    );
  } else {
    return (
      <ModalTrigger>
        {(isVisible, showModal, hideModal) => (
          <button className="btn btn-md btn-success" onClick={showModal}>
            <span className={"glyphicon glyphicon-ok"}></span>
            {isVisible && <ModalLiderMasivo0Nominas hideModal={hideModal} />}
          </button>
        )}
      </ModalTrigger>
    );
  }
};



// WEBPACK FOOTER //
// ./frontEnd/inventarios/programacion-semanal/ProgramacionIGSemanal.jsx